import { uri } from './util'

// const BASE = "http://localhost:8787/api"
const BASE = "/api"

async function api(method: string, path: string, opts: any = {}) {
  opts.method = method
  const res = await fetch(BASE+path, opts)
  if (res.status != 200) {
    throw 'Bad Response from API: '+res.status
  }
  return await res.json()
}

// Chat message
export interface Message {
  who: string,
  text: string,
  ts: number,
}

// Conversation thread handler
//
// Primarily tracks conversation id and previous messsage id
export class Conversation {
  // gptchat conversation id
  conversation_id: string|null

  // last message id
  id: string|null

  constructor() {
    console.log('conversation init')

    this.conversation_id = null
    this.id = null
  }

  // call gptchat with conversation context
  async converse(prompt: string) {
    console.log('before', this.conversation_id, this.id)
    const res = await api('POST', uri`/converse`, {
      body: JSON.stringify({
        conversation_id: this.conversation_id,
        id: this.id,
        prompt,
      })
    }) as any
    this.conversation_id = res.conversation_id
    this.id = res.id
    console.log('after', this.conversation_id, this.id)
    return res.msg
  }
}

export async function session(sessionToken: string) {
  const res = await api('POST', uri`/session`, {
    body: sessionToken
  })
}

// Call TTS api (converts text to media URL)
export async function speak(msg: string) {
  const res = await api('GET', uri`/speak?t=${msg}`)

  return res.url
}

// convert binary media blob to text
export async function transcribe(blob: Blob) {
  const res = await api('POST', uri`/transcribe`, {
    body: blob,
  })

  return res.text
}

